module.exports = __webpack_public_path__ + "images/05d0231e6e5524df251990b6fa288484.svg";